import { render, staticRenderFns } from "./ListSelect.vue?vue&type=template&id=2b52d24b&"
import script from "./ListSelect.vue?vue&type=script&lang=ts&"
export * from "./ListSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports